import VChartsLoader from './lib/vcharts_loader.js';

class StoragePricesPage {
  constructor() {
    this.vchartsLoader = new VChartsLoader();
  }

  setup_menu_link_callback() {
    $('.menu-link').each(function() {
      $(this).on('click', function(event) {
        var target = $(event.target).attr('href');
        $('html, body').animate({
          scrollTop: $(target).offset().top - $('.vpsb-navbar').height()
        }, 500);
        window.location.hash = target.substr(1);
        return false;
      });
    });
  }

  load_block_storage_price_chart() {
    this.load_storage_price_chart('#block-storage-price-chart');
  }

  load_object_storage_price_chart() {
    this.load_storage_price_chart('#object-storage-price-chart');
  }

  load_storage_price_chart(canvasSelector) {
    var canvas = $(canvasSelector);
    if (canvas.length == 0) {
      console.error(canvasSelector + " is missing from all_storage_prices page");
      return;
    }

    var ctx = canvas.get(0).getContext("2d");
    var labels = JSON.parse(canvas[0].dataset.labels);
    var values = JSON.parse(canvas[0].dataset.values);

    this.vchartsLoader.vpsb_bar_chart(ctx, canvas.attr('id'), labels, values,
                                      '$ / GB / month', 'Price / GB / month',
                                      'horizontal', false, 0);
  }
}

$(document).on('turbo:load', function() {
  if ($("body.hosters.all_storage_prices").length == 0) {
    return;
  }
  console.log("page load in storage_prices.js...");

  var storage_prices_page = new StoragePricesPage();
  storage_prices_page.setup_menu_link_callback();
  storage_prices_page.load_block_storage_price_chart();
  storage_prices_page.load_object_storage_price_chart();
} );
